import type { ReactElement, ReactNode } from 'react';
import styles from './Choice.module.scss';

/**
 * Плитка-кнопка: выбор варианта с превью (тема) или быстрый выбор из списка (демо-учётка).
 * С checked ведёт себя как переключатель группы (role="radio").
 */
export function ChoiceTile({ checked, title, onSelect, children }: { checked?: boolean; title?: string; onSelect(): void; children: ReactNode }): ReactElement {
  return (
    <button
      type="button"
      role={checked === undefined ? undefined : 'radio'}
      aria-checked={checked}
      className={styles.tile}
      title={title}
      onClick={onSelect}
    >
      {children}
    </button>
  );
}

/** Группа плиток с подписью для экранных читалок. */
export function ChoiceGroup({ label, children, columns = 'auto' }: { label: string; children: ReactNode; columns?: 'auto' | 'two' | 'one' }): ReactElement {
  return (
    <div className={`${styles.group} ${styles[columns]}`} role="radiogroup" aria-label={label}>
      {children}
    </div>
  );
}

export interface SegmentOption<K extends string> {
  value: K;
  label: ReactNode;
}

/** Переключатель из нескольких сегментов (режим темы). */
export function SegmentedControl<K extends string>({ label, options, value, onChange }: { label: string; options: readonly SegmentOption<K>[]; value: K; onChange(value: K): void }): ReactElement {
  return (
    <div className={styles.segments} role="radiogroup" aria-label={label}>
      {options.map((option) => (
        <button key={option.value} type="button" role="radio" aria-checked={option.value === value} className={styles.segment} onClick={() => onChange(option.value)}>
          {option.label}
        </button>
      ))}
    </div>
  );
}
